.panel {
    width: 720px;
}

.title {
    margin-right: calc(-1 * var(--close-button-size));
    text-align: center;
}
